import { render, staticRenderFns } from "./ednField.vue?vue&type=template&id=800b5334&scoped=true"
import script from "./ednField.vue?vue&type=script&lang=js"
export * from "./ednField.vue?vue&type=script&lang=js"
import style0 from "./ednField.vue?vue&type=style&index=0&id=800b5334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800b5334",
  null
  
)

export default component.exports